/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import { Pipe, PipeTransform } from '@angular/core';

export interface PaginationInstance{
  id?:string;
  itemsPerPage:number;
  currentPage:number;
  totalItems?:number;
}
@Pipe({
  name: 'paginater',
})
export class PaginatePipe implements PipeTransform {

  transform(array: any[], page_size: string | number, page_number: number):any[] {
    if (!array.length) return [];
    if (page_size === 'all') {
      return array;
    }

    page_size = page_size || 5;
    page_number = page_number || 1;
    --page_number;
    // @ts-ignore 
    return array.slice(page_number * page_size, (page_number + 1) * page_size);

  }

}
